import React from 'react';
import { Button } from '@/components/ui/button';
import { Calendar, Plus, Trash2 } from 'lucide-react';

export function ManagerUnavailabilityTab({ ctx }) {
  const { unavailability, isOwnBranch, setShowUnavailability, handleDeleteUnavailability } = ctx;

  return (
    <div className="bg-white rounded-xl shadow-md border border-stone-200 p-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-stone-800">Staff Unavailability</h2>
          <p className="text-sm text-stone-600 mt-1">View and manage staff unavailable dates</p>
        </div>
        <Button
          onClick={() => setShowUnavailability(true)}
          data-testid="add-unavailability-button"
          className="bg-gradient-to-r from-gray-600 to-gray-700 hover:bg-gray-700 text-white"
          disabled={!isOwnBranch}
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Unavailability
        </Button>
      </div>
      {unavailability.length > 0 ? (
        <div className="space-y-3">
          {unavailability.map(unavail => (
            <div
              key={unavail.id}
              data-testid={`unavail-${unavail.id}`}
              className="border border-stone-200 rounded-lg p-4 hover:shadow-md transition"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="font-semibold text-stone-800">{unavail.username}</div>
                  <div className="text-sm text-stone-600 mt-1">
                    {new Date(unavail.date_from).toLocaleDateString()} - {new Date(unavail.date_to).toLocaleDateString()}
                  </div>
                  {unavail.reason && <div className="text-xs text-stone-500 mt-1">{unavail.reason}</div>}
                </div>
                {isOwnBranch && (
                  <Button
                    onClick={() => handleDeleteUnavailability(unavail.id)}
                    data-testid={`delete-unavail-${unavail.id}`}
                    variant="ghost"
                    size="sm"
                    className="text-red-600 hover:text-red-800 hover:bg-red-50"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-stone-500">
          <Calendar className="w-12 h-12 mx-auto mb-3 text-stone-400" />
          <p>No unavailability periods set</p>
        </div>
      )}
    </div>
  );
}
